import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="No-Poverty--Streamline-Flex"
    >
        <desc>{'No Poverty Streamline Icon: https://streamlinehq.com'}</desc>
        <g id="no-poverty">
            <path
                id="Intersect"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.267 13.5c-0.1696 -0.6835 -0.55605 -1.2953 -1.10326 -1.7426 -0.58345 -0.4769 -1.31383 -0.7374 -2.06737 -0.7374 -0.75355 0 -1.48392 0.2605 -2.06737 0.7374 -0.54721 0.4473 -0.93361 1.0591 -1.10322 1.7426"
                strokeWidth={1}
            />
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.09601 11.0201c1.24269 0 1.94171 -0.699 1.94171 -1.94167 0 -1.2427 -0.69902 -1.94171 -1.94171 -1.94171 -1.2427 0 -1.94171 0.69901 -1.94171 1.94171 0 1.24267 0.69901 1.94167 1.94171 1.94167Z"
                strokeWidth={1}
            />
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.3292 4.38342c1.2427 0 1.9417 -0.69901 1.9417 -1.94171C12.2709 1.19902 11.5719 0.5 10.3292 0.5c-1.24273 0 -1.94175 0.69902 -1.94175 1.94171 0 1.2427 0.69902 1.94171 1.94175 1.94171Z"
                strokeWidth={1}
            />
            <path
                id="Subtract"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.4999 6.86326c-0.1696 -0.68351 -0.556 -1.2953 -1.1032 -1.74257 -0.5834 -0.47688 -1.3138 -0.73739 -2.0674 -0.73739 -0.75351 0 -1.48389 0.26051 -2.06734 0.73739"
                strokeWidth={1}
            />
            <path
                id="Vector_3"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.67084 4.38342c-1.2427 0 -1.94171 -0.69901 -1.94171 -1.94171C1.72913 1.19902 2.42814 0.5 3.67084 0.5c1.24269 0 1.94171 0.69902 1.94171 1.94171 0 1.2427 -0.69902 1.94171 -1.94171 1.94171Z"
                strokeWidth={1}
            />
            <path
                id="Subtract_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.50008 6.86326c0.169602 -0.68351 0.55601 -1.2953 1.10322 -1.74257 0.58345 -0.47688 1.31382 -0.73739 2.06737 -0.73739 0.75354 0 1.48392 0.26051 2.06737 0.73739"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
